import { BASE_SCENARIO_ID } from '~/ERP/ERPScenarioSelect';
import { Action, ActionType } from './Action';

export interface State {
	leftSelectedScenarioId: string;
	rightSelectedScenarioId: string | null;
}

function createState(): State {
	return {
		leftSelectedScenarioId: BASE_SCENARIO_ID,
		rightSelectedScenarioId: null,
	};
}

export default function reducer(state: State = createState(), action: Action) {
	switch (action.type) {
		case ActionType.setLeftId:
			return { ...state, leftSelectedScenarioId: action.payload };
		case ActionType.setRightId:
			return { ...state, rightSelectedScenarioId: action.payload };
		default:
			return state;
	}
}
